import type { CSSProperties } from 'react';
import { cx } from '@/shared/lib/cx';
import s from './Feedback.module.css';

export interface SkeletonProps {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  radius?: CSSProperties['borderRadius'];
  className?: string;
}

/** Заглушка формы содержимого на время загрузки (для экранных дикторов — скрыта; статус объявляет контейнер). */
export function Skeleton({ width = '100%', height = 16, radius, className }: SkeletonProps) {
  return <span className={cx(s.skeleton, className)} style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx(s.skeletonText, className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} className={cx(s.skeleton, s.skeletonLine)} style={{ width: index === lines - 1 && lines > 1 ? '60%' : '100%' }} />
      ))}
    </span>
  );
}
